import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@mono/ui-components';
import { ChevronUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { useDarkMode } from '../contexts/darkModeContext';
import { useFeatureFlag, useFeatureFlagsReady } from '../contexts/featureFlagContext';
import { toast } from './toast';
export function SidebarUserNav({ user, isCollapsed = false }) {
    const navigate = useNavigate();
    const { logout, isLoading } = useAuth();
    const { isDarkMode, toggleDarkMode } = useDarkMode();
    const flagsReady = useFeatureFlagsReady();
    const specraRedesignEnabled = useFeatureFlag('specra_redesign_dashboard');
    const specraRedesign = flagsReady && specraRedesignEnabled;
    const handleSignOut = async ()=>{
        if (isLoading) {
            toast({
                type: 'error',
                description: 'Please wait, processing...'
            });
            return;
        }
        try {
            await logout();
        } catch (_error) {
            toast({
                type: 'error',
                description: 'Failed to sign out. Please try again.'
            });
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "px-2 py-2",
        children: /*#__PURE__*/ _jsxs(DropdownMenu, {
            children: [
                /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                    asChild: true,
                    children: /*#__PURE__*/ _jsxs("button", {
                        type: "button",
                        className: "w-full h-10 flex items-center gap-2 rounded-md px-2 text-left transition-colors text-muted-foreground hover:bg-muted/50",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: `https://avatar.vercel.sh/${user.email}`,
                                alt: user.email ?? 'User Avatar',
                                width: 24,
                                height: 24,
                                className: "rounded-full"
                            }),
                            !isCollapsed && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "truncate text-sm",
                                        children: user.email
                                    }),
                                    /*#__PURE__*/ _jsx(ChevronUp, {
                                        className: "ml-auto h-4 w-4"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                    side: "top",
                    className: "w-[--radix-popper-anchor-width]",
                    children: [
                        specraRedesign && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                    className: "cursor-pointer",
                                    onSelect: ()=>navigate('/settings'),
                                    children: "Settings"
                                }),
                                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                    className: "cursor-pointer",
                                    onSelect: ()=>navigate('/help'),
                                    children: "Help"
                                }),
                                /*#__PURE__*/ _jsx(DropdownMenuSeparator, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DropdownMenuItem, {
                            className: "cursor-pointer",
                            onSelect: toggleDarkMode,
                            children: `Toggle ${isDarkMode ? 'light' : 'dark'} mode`
                        }),
                        /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                        /*#__PURE__*/ _jsx(DropdownMenuItem, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "w-full cursor-pointer text-left",
                                onClick: handleSignOut,
                                children: "Sign out"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
